let { monkey } = require('baobab');
let moment = require('moment');
let { pluralize } = require('../../../../helpers/utils');

module.exports = {
    firmsPluralized (state) {
        state.set(['order', 'price', 'computed', 'firmsPluralized'], monkey(
            ['order', 'price', 'data', 'rowAmount'],
            (amount) => pluralize(amount, ['фирма', 'фирмы', 'фирм'])
        ));
    },

    /**
     * Вычисляем применяется ли скидка для общей цены заказа, если да, то записываем в дерево цену без скидки
     * @param {Object} state
     */
    isBasicPriceAnyDiscount (state) {
        state.set(['order', 'price', 'computed', 'rowPriceWithoutDiscount'], monkey(
            ['order', 'price', 'data', 'basic', 'rowPriceWithoutDiscount'],
            ['order', 'price', 'data', 'basic', 'rowPrice'],
            (priceFull, priceDiscount) => {
                if (priceDiscount !== priceFull) {
                    return priceFull;
                }
            }
        ));
    },

    datepicker (state) {
        state.set(['order', 'addParams', 'computed', 'datepicker'], monkey(
            ['order', 'addParams', 'datepicker', 'value'],
            ['order', 'addParams', 'datepicker', 'calendar'],
            ['order', 'addParams', 'datepicker', 'ui', 'isDisabled'],
            (selectedDate, calendar, isDisabled) => {
                let today = moment().subtract(1, 'day').unix();
                let title = selectedDate ? moment.unix(selectedDate).format('DD.MM.YYYY') : '';
                let calendars = calendar ? calendar : [{ date: today }];

                return {
                    mod: 'discounts',
                    withoutButton: true,
                    withInputs: false,
                    availableRange: {
                        from: moment({ year: 2000, month: 0 }).unix(),
                        till: today
                    },
                    calendars,
                    selectedDate,
                    title: { date: title },
                    isDisabled
                };
            }
        ));
        state.set(['order', 'addParams', 'computed', 'datepicker2'], monkey(
            ['order', 'addParams', 'datepicker2', 'value'],
            ['order', 'addParams', 'datepicker2', 'calendar'],
            ['order', 'addParams', 'datepicker2', 'ui', 'isDisabled'],
            (selectedDate, calendar, isDisabled) => {
                let today = moment().subtract(1, 'day').unix();
                let title = selectedDate ? moment.unix(selectedDate).format('DD.MM.YYYY') : '';
                let calendars = calendar ? calendar : [{ date: today }];

                return {
                    mod: 'discounts',
                    withoutButton: true,
                    withInputs: false,
                    availableRange: {
                        from: moment({ year: 2000, month: 0 }).unix(),
                        till: today
                    },
                    calendars,
                    selectedDate,
                    title: { date: title },
                    isDisabled
                };
            }
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/order/price/index.js